import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { pageResetMiddleWare, zodOptionalId, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const groupClaimsRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/claims',
  validateSearch: z.object({
    tab: z
      .enum(['all', 'published', 'transmitted', 'pending', 'closed_by_lab', 'archived_by_pharmacy'])
      .default('all'),
    page: zodPage,
    labId: zodOptionalId,
    pharmacyId: zodOptionalId,
    query: z.string().optional(),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/group/Claims/GroupClaimsPage/GroupClaimsPage').then((d) => d.Route));
